export default {
  content: "If you're feeling confused or would like a referral to a housing counselor or legal services provide, we are available to help at:",
  phone: "<a href='tel:646-786-0888'>646-786-0888</a>"
};
